import { attachAccordionHandlers } from "../ui/accordion";

export function attachProductEvents() {
  attachAccordionHandlers();

  window.onload = showFeefoReviews;

  $(document).on("click", ".feefo-link", scrollToFeefoReviews);
  $(document).on("click", "#trusted-partner-badge", scrollToDeliveryInfo);
}

var selectors = {
  videoButton: ".product__videoButton",
  videoAccordion: "#video-accordion"
}

var videoButtonElement = document.querySelector(selectors.videoButton);

if(videoButtonElement) {
  videoButtonElement.addEventListener("click", scrollToVideo);
}

function scrollToDeliveryInfo() {
  var delivery_accordion = $('.delivery-accordion')

  delivery_accordion.addClass('opened')

  $('html,body').animate({
    scrollTop: delivery_accordion.offset().top
  }, 500);
}

function scrollToFeefoReviews() {
  var reviews_accordion = $('.reviews-accordion')

  reviews_accordion.addClass('opened')

  $('html,body').animate({
    scrollTop: reviews_accordion.offset().top
  }, 500);
}

function showFeefoReviews() {
  // Supports Enhanced(shadowRoot) and Legacy feefo widgets  
  if (document.querySelector(".feefo-block")) {
    var feefoWidget = document.querySelector(".feefo-product-stars-widget");
    if (feefoWidget != null) {
      if ( feefoWidget.shadowRoot != null && feefoWidget.shadowRoot.innerHTML.length != 0) {
        document.querySelector(".feefo-block").style.removeProperty('display');
        document.querySelector(".reviews-accordion").classList.remove("hidden");
      } else if (feefoWidget.innerText.length != 0) {
        document.querySelector(".feefo-block").style.removeProperty('display');
        document.querySelector(".reviews-accordion").classList.remove("hidden");
      }
    } 
  }
} 

function scrollToVideo(event) {
  event.preventDefault();
  var videoAccordionElement = $(selectors.videoAccordion);

  videoAccordionElement.addClass('opened');

  $('html,body').animate({
    scrollTop: videoAccordionElement.offset().top
  }, 500); 
}

